import LoginForm from 'modules/Forms/Auth/Login'
import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { Redirect } from 'react-router'
import { ROUTES } from 'constants/routes'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { Nav } from 'layouts/AuthLayout/subcomponents'
import { SET_AUTH } from 'modules/Auth/types'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'

const Login = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const refresh_token = localStorage.getItem('refresh_token')
  const pathGen = useGeneratePathI18n()
  const breakpoint = useBreakpoint()

  useEffect(
    () => !!refresh_token && dispatch({ type: SET_AUTH, payload: true }),
    [],
  )

  return refresh_token ? (
    <Redirect to={pathGen(ROUTES.SERVICES)} />
  ) : (
    <>
      <Helmet defer={false}>
        <title>{t('auth::login.title')}</title>
      </Helmet>
      <Nav
        className={breakpoint.fbs ? 'margin-bottom-32' : 'margin-bottom-40'}
      />
      <LoginForm />
    </>
  )
}

export default Login
